// Shared photo constants used by every collection module.
// Iteration 78: all approved public imagery migrated to same-origin
// Vanturis paths (/assets/coach-photos/...) so no third-party CDN URL
// is referenced in the built frontend.  Filenames preserve the original
// artifact IDs so historical references stay traceable.  Do NOT introduce
// collection-specific imports here — this file is the base for every
// collection.
export const _BASE = "/assets/coach-photos";

// Exterior photos (10). Iteration 31 HD gate — same-category positional swaps
// so that any full-width usage (auctions hero, home split hero, editorial
// marquee first frames) hits an approved HD file from the library.
export const EXTERIOR_PHOTOS = [
  `${_BASE}/q7uje42u_IMG_5548.jpeg`,  // 0 - dark grey Prevost w/ awning, palms (1200x800 — marquee only)
  `${_BASE}/mdesfgc5_IMG_5544.webp`,  // 1 - black Prevost bronze, palms bikes (1920x1281 HD) — Bidding Marketplace hero
  `${_BASE}/gmf5f1wb_IMG_5538.webp`,  // 2 - Prevost X3-45 side profile (2000x1333 HD) — home marquee/split hero
  `${_BASE}/bro2du46_IMG_5545.webp`,  // 3 - blue Prevost, sky (860x485 — small only)
  `${_BASE}/j5i0c0g7_IMG_5547.jpeg`,  // 4 - black Prevost X3-45, palms (1000x667 — small only)
  `${_BASE}/pd1l0vwe_IMG_5543.webp`,  // 5 - motorcoach resort rows (2000x994 HD)
  `${_BASE}/f293owpn_IMG_5542.webp`,  // 6 - Prevost X3-45 aspens fall (1920x975 HD)
  `${_BASE}/30b499xl_IMG_5540.webp`,  // 7 - black Prevost desert sunset (2000x972 HD)
  `${_BASE}/ezpqsdbl_IMG_5539.jpeg`,  // 8 - Prevost front cockpit (700x532 — small only)
  `${_BASE}/jirlfqta_IMG_5546.jpeg`,  // 9 - blue Prevost XLII, waterfront (383x522 — small only)
];

// Interior photos (8) — Vanturis-approved, branding-free interiors.
// IMG_5550 / 5551 / 5553 / 5555 have been removed because they contained
// third-party branding; do not re-introduce them.
export const INTERIOR_PHOTOS = [
  `${_BASE}/ps243jv0_IMG_5552.jpeg`,  // 0 - cream/mocha modern, upper cabinets (1280x720)
  `${_BASE}/o4109o5q_IMG_5549.jpeg`,  // 1 - walnut art-deco lounge, zebra rug (472x315 — small only)
  `${_BASE}/qb18eiau_IMG_5558.jpeg`,  // 2 - marble floor modern white walnut galley (1920x1080 HD) — Concierge bg
  `${_BASE}/9vtvfw45_IMG_5559.jpeg`,  // 3 - dark noir galley with beige leather (388x515 — small only)
  `${_BASE}/ec04xbzm_IMG_5557.jpeg`,  // 4 - white contemporary master bedroom (1920x900 HD)
  `${_BASE}/k2qqty8r_IMG_5554.jpeg`,  // 5 - dark grid ceiling with wood floor lounge (678x452 — small only)
  `${_BASE}/67xiasx4_IMG_5561.jpeg`,  // 6 - noir dinette, twin city-scape TVs (388x515 — small only)
  `${_BASE}/64h5ezje_IMG_5562.jpeg`,  // 7 - modern cream banquette + walnut, side view (447x447 — small only)
];

// Master trailer collection image — used everywhere the general trailer
// collection is represented (homepage card, /tour-trailers-preview hero,
// future live trailers collection page, banners, etc.).
export const TRAILER_MASTER_IMAGE = `${_BASE}/u53vfcg3_trailer_master.png`;

export const COACH_PHOTOS = [...EXTERIOR_PHOTOS, ...INTERIOR_PHOTOS];

// Hero rotator: only slides at or above the 1600px full-width-desktop threshold.
export const HERO_ROTATION = [
  EXTERIOR_PHOTOS[7],  // 30b499xl · black Prevost desert sunset  (2000×972)
  EXTERIOR_PHOTOS[6],  // f293owpn · Prevost X3-45 aspens fall     (1920×975)
  EXTERIOR_PHOTOS[5],  // pd1l0vwe · motorcoach resort rows        (2000×994)
  INTERIOR_PHOTOS[4],  // ec04xbzm · white contemporary bedroom    (1920×900)
];

// Editorial marquee — full set for continuous scroll
export const EDITORIAL_MARQUEE = COACH_PHOTOS;

// Second marquee row (interiors focused, reverse direction)
export const INTERIOR_MARQUEE = [...INTERIOR_PHOTOS, ...INTERIOR_PHOTOS, ...INTERIOR_PHOTOS];

// Alt-collection base — Phase B/C custom photography uploads (Iter 78:
// also same-origin now).
export const _ASSET_BASE = "/assets/coach-photos";
